import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type DownloadRfpLanesTemplateFileFactoryDependencies = {
  repository: ProposalRepository
}

export function downloadRfpLanesTemplateFileFactory({
  repository,
}: DownloadRfpLanesTemplateFileFactoryDependencies) {
  return async function download(id: string, config?: { signal: AbortSignal }) {
    try {
      return await repository.downloadRfpLanesTemplateFile(id, config)
    } catch (error) {
      throw new Error('Failed to download rate template', { cause: error as Error })
    }
  }
}

export function downloadRfpLanesTemplateFile(id: string, config?: { signal: AbortSignal }) {
  const httpClient = new ShipperGuideClient()
  const repository = new ProposalRepository({ httpClient })
  const download = downloadRfpLanesTemplateFileFactory({ repository })

  return download(id, config)
}
